import React, { useEffect, useState } from 'react'
import { RootState } from 'App'
import { useSelector } from 'react-redux'
import { AppToggleButton } from 'components/Common/AppToggleButton/AppToggleButton.component'
import { useUpdateMyProfileMutation } from '__generated__/api-types-and-hooks'

export const AppGiveConsentToAdvisor = () => {
  const [isToggled, setIsToggled] = useState(false)

  const user = useSelector((state: RootState) => state.user)
  const { mutate, isLoading, isError } = useUpdateMyProfileMutation()
  const userPermissionHandler = () => {
    mutate({
      input: {
        userId: user.user.id,
        tenantId: user.tenantId,
        isConsentGivenToAdvisor: !isToggled,
      },
    })
    setIsToggled(!isToggled)
  }

  useEffect(() => {
    setIsToggled(user.user?.isConsentGivenToAdvisor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsToggled(user.user?.isConsentGivenToAdvisor)
      }, 1000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError])

  return (
    <div className="mt-14">
      <div className="py-7 px-8 bg-white border border-primary-outline rounded-lg">
        <p className="font-[650]">Share your data charts</p>
        <div className="lg:flex justify-between">
          <p className="pt-4 grid grid-cols-1 lg:grid-cols-2">
            By allowing your advisor to view your data, they will have access to valuable
            information that will strengthen data driven advising for your business.
          </p>
          {isError && isToggled !== user.user?.isConsentGivenToAdvisor && (
            <div className="text-primary-error">Unable to give consent to advisor</div>
          )}
          <div className="shrink-0 pr-8">
            <AppToggleButton
              isToggled={isToggled}
              toggleButtonHandler={userPermissionHandler}
              label="Share with advisor"
              disabled={isLoading}
            />
          </div>
        </div>
        <p className="pt-6">
          Your data is private, and will only be visible to your assigned advisor.
        </p>
      </div>
    </div>
  )
}
